export {
  FileDisplayIconType,
  FileDisplaySize,
  FileDisplayType,
} from './file-display.component';
